// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31PAO","colBig":"styles_colBig__UxRcX","colSmall":"styles_colSmall__dxrqp"};